export { InvalidNameError } from "./values/name/name";
export { InvalidEmailAddressError } from "./values/email-address/email-address";
export { InvalidPasswordError } from "./values/password/password";

export class InvalidURLError extends Error {
  constructor(url: string) {
    super(`Invalid URL: ${url}`);
  }
}